"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEAD_GEN_CONSTS = void 0;
exports.LEAD_GEN_CONSTS = {
    LipSyncLeadTokenMetadataKey: 'lipSyncLeadToken',
};
